export default "__VITE_ASSET__ClxJN8ls__"